export default __webpack_public_path__ + "static/media/level-6.7c3408c3.png";